<template>
	<div>
		<header class="page-title">
			<h2>Permissions</h2>
			<div class="ml-auto">
				<a @click="savePermissions" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="grid--nav-horizontal">
			<nav class="nav-horizontal">
				<ul>
					<li :class="[activeTab.name === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs">
						<a @click.prevent="setActiveTabName(tab)">{{ tab.displayName }}</a>
					</li>
				</ul>
			</nav>
			<div class="nav-horizontal-contents">
				<div v-if="activeTab.name === 'general'">
					<div class="check-all-roles">
						<label class="label-flex mb-0"><input type="checkbox" @click="superCheckAll(activeTab.name, $event)"> Check all roles</label>
					</div>
					<div class="flex box">
						<table class="user-permissions six mb-2" v-for="(role, roleName) in availableRoles.general">
							<thead>
								<tr>
									<th>{{ roleName }}</th>
									<th class="with-checkbox">
										<label class="label-flex mb-0"><input type="checkbox" @click="checkAll(activeTab.name, roleName, $event)"> Check all</label>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in role">
									<td>{{ index }}</td>
									<td>
										<input v-model="item.userHas"
											   type="checkbox">
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div v-else v-for="tab in siteTabs">
					<div v-if="tab.name === activeTab.name && activeTab.name !== 'languages'">
						<div class="check-all-roles">
							<label class="label-flex mb-0"><input type="checkbox" @click="superCheckAll(activeTab.id, $event)"> Check all roles</label>
						</div>
						<div class="flex box">
							<table class="user-permissions six mb-2" v-for="(role, roleName) in availableRoles.site[activeTab.id]">
								<thead>
									<tr>
										<th>{{ roleName }}</th>
										<th class="with-checkbox">
											<label class="label-flex mb-0"><input type="checkbox" @click="checkAll(activeTab.id, roleName, $event)"> Check all</label>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in role">
										<td>{{ index }}</td>
										<td>
											<input v-model="item.userHas"
												   type="checkbox">
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div v-if="activeTab.name === 'languages'">
						<div class="flex box">
							<div class="flex box">
								<table class="user-permissions six mb-2">
									<thead>
										<tr>
											<th colspan="2">Languages</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(language, index) in availableLanguages" v-if="language.locale !== 'en'">
											<td>{{ language.title }}</td>
											<td>
												<input :checked="translatorLanguages.includes(language.id)" type="checkbox" @change="modifyLanguages(language.id,$event)">
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		dataAvailableRoles: {
			type: Object
		},
		dataUserRoles: {
			type: Array
		},
		dataUserId: {
			type: Number
		},
		dataTranslatorLanguages: {
			type: Array
		}
	},
	data() {
		return {
			availableRoles: this.dataAvailableRoles,
			availableLanguages: this.$availableLanguages,
			userRoles: this.dataUserRoles,
			userId: this.dataUserId,

			translatorLanguages: this.dataTranslatorLanguages,

			tabs: [],
			siteTabs: [],
			activeTab: null,
		}
	},
	created() {
		let vm = this;

		vm.tabs.push({
			displayName: 'General',
			name: 'general',
			id: null
		});

		vm.activeTab = this.tabs[0];

		for (let i = 0; i < vm.$availableSites.length; i++) {
			vm.tabs.push({
				displayName: vm.$availableSites[i].name,
				name: vm.$availableSites[i].slug,
				id: vm.$availableSites[i].id
			});

			vm.siteTabs.push({
				displayName: vm.$availableSites[i].name,
				name: vm.$availableSites[i].slug,
				id: vm.$availableSites[i].id
			});
		}

		this.selectedUserRoles();

	},
	methods: {
		setActiveTabName: function (tab) {
			this.activeTab = tab;
		},
		savePermissions: function () {
			let vm = this;

			vm.availableRoles.translatorLanguages = this.translatorLanguages;

			axios.post('/api/users/' + vm.userId + '/permissions/', vm.availableRoles)
					.then(response => {
						vm.$toastr.success('Permissions saved successfully', 'Success');
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						vm.$toastr.error('Permissions save failed.', 'Error');
					});
		},
		checkAll: function (tab, roleName, event) {
			let status = event.target.checked;

			if (tab !== 'general') {
				Object.values(this.availableRoles.site[tab][roleName]).forEach(function (role) {
					role.userHas = status;
				});
			} else {
				Object.values(this.availableRoles.general[roleName]).forEach(function (role) {
					role.userHas = status;
				});
			}
		},
		superCheckAll: function (tab, event) {
			let status = event.target.checked;

			if (tab !== 'general') {
				Object.values(this.availableRoles.site[tab]).forEach(function (role) {
					Object.values(role).forEach(function (element) {
						element.userHas = status;
					});
				});
			} else {
				Object.values(this.availableRoles.general).forEach(function (role) {
					Object.values(role).forEach(function (element) {
						element.userHas = status;
					});
				});
			}
		},
		selectedUserRoles: function () {
			let roles = [];
			let vm = this;
			this.userRoles.forEach(function (roleBlock) {
				roles.push(roleBlock.role_name);
			});
			let includes = false;
			this.tabs.forEach(function (tab, index) {
				if (tab.name === 'languages') {
					includes = index;
				}
			});
			if (roles.includes('users.translator') && includes === false) {
				vm.tabs.push({
					displayName: 'Languages',
					name: 'languages',
					id: null
				});
			}
			if (!roles.includes('users.translator') && includes !== false) {
				vm.$delete(vm.tabs, includes);
			}
			vm.$forceUpdate();
			return roles;
		},
		modifyLanguages: function (id, event) {
			if (event.target.checked === true) {
				this.translatorLanguages.push(id);
			} else {
				this.translatorLanguages.splice(this.translatorLanguages.indexOf(id), 1);
			}
		},
	}
}
</script>
